import React, { useEffect, useState } from 'react'
import { loadLanguages, loadTalent, loadTalents, saveTalent, setTalentSortOrder } from '../utils/Network';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { getDefaultName, talentImageSrc } from '../utils';
import SelectAllTalents from '../components/SelectAllTalents';
import SelectStatus from '../components/select/SelectStatus';
import SelectMenu from '../components/SelectMenu';
import Gallery from './Gallery';
import TabsWidget from './shared/dashboard/widgets/TabsWidget';

export default function TalentContent({ id, isModal = false, onClose = null, onSaved = null }) {

    const [talentNames, setTalentNames] = useState(null);
    const [languages, setLanguages] = useState(null);
    const [parent, setParent] = useState(null)
    const [status, setStatus] = useState(null)
    const [menu, setMenu] = useState(false)
    const [image, setImage] = useState(false)
    const [header, setHeader] = useState(false)

    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
    const [selected_image_type, setSelectedImageType] = useState(false);


    const [activeLanguage, setActiveLanguage] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [current_childs, setCurrentChilds] = useState(null);
    const [show_children, setShowChildren] = useState(false);

    useEffect(() => {
        setTalentNames(null);
        setParent(null);
        setStatus(null);
        setMenu(false);
        setImage(false);
        setHeader(false);
        setError(null);
        setCurrentChilds(null);
        setShowChildren(false);

        loadLanguages().then(languages => {

            //languages=languages.filter(x=> x.language !==16)
            setLanguages(languages);
            const def = languages.find(l => l.is_default) || languages[0];
            if (def) setActiveLanguage(def.id);

        });

        loadTalents().then(talents => {
            if (id) {
                var childs = talents.filter(x => x.parent == id);
                setCurrentChilds(childs);

            }
        });



        if (id) {
            loadTalent(id).then(Talent => {

                setTalentNames(Talent.names)
                console.log(Talent)
                const rawParent =
                    Talent.parent != null && Talent.parent !== ''
                        ? Talent.parent
                        : Talent.parent_id
                if (rawParent != null && rawParent !== '') {
                    const p = rawParent
                    setParent(typeof p === 'object' && p !== null && p.id != null ? p.id : p)
                } else {
                    setParent(null)
                }
                setStatus(Talent.status)
                setMenu(Talent.menu)
                setImage(talentImageSrc(Talent, ''))
                setHeader(talentImageSrc({ image_url: Talent.header_url, image: Talent.header }, ''))
            }).then(() => {

            });

        }



    }, [id])


    const handleOnChange = (e) => {
        //alert(e.target.value)
        var language_id = e.target.getAttribute("language_id")

        var name = null;
        if (talentNames) {
            name = talentNames.find(x => x.language === parseInt(language_id));
        }
        if (name) {
            var temp_talentNames = [...talentNames];
            temp_talentNames.find(x => x.language === parseInt(language_id)).name = e.target.value;
            setTalentNames(temp_talentNames)
        }
        else {

            var new_name = { name: e.target.value, language: parseInt(language_id) }
            var temp_talentNamesa = [];
            if (talentNames)
                temp_talentNamesa = [...talentNames, new_name];
            else temp_talentNamesa = [new_name]
            setTalentNames(temp_talentNamesa)
        }
    }

    const handleDescriptionChange = (language_id, data) => {
        //alert(e.target.value)

        var name = null;
        if (talentNames) {
            name = talentNames.find(x => x.language === parseInt(language_id));
        }
        if (name) {
            var temp_names = [...talentNames];
            temp_names.find(x => x.language === parseInt(language_id)).description = data;
            setTalentNames(temp_names)
        }
        else if (!id) {

            var new_name = { name: "", description: data, language: parseInt(language_id) }
            var temp_namesa = [];
            if (talentNames)
                temp_namesa = [...talentNames, new_name];
            else temp_namesa = [new_name]
            setTalentNames(temp_namesa)
        }
    }


    const handleValue = (value, name) => {
        switch (name) {
            case "talent":
                setParent(value)
                break;
            case "status":
                setStatus(value)
                break;
            case "menu":
                setMenu(value)
                break;
            default:
                break;
        }
    }

    const saveChanges = () => {
        setError(false);
        setLoading(true);
        //alert(talentNames[0].name)
        if (!talentNames || talentNames[0].name.length < 3) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }
        if (talentNames.length < languages.length) {
            setError('Please Enter Name in all languages');
            setLoading(false);
            return;
        }
        if (talentNames && talentNames.length > 1 && talentNames[1].name.length < 3) {
            setError('Please Enter Name 2');
            setLoading(false);
            return;
        }
        if (talentNames && talentNames.length > 2 && talentNames[2].name.length < 3) {
            setError('Please Enter Name 3');
            setLoading(false);
            return;
        }
        if (!talentNames || talentNames[0].name.length < 3) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }
        saveTalent({ id: id, names: talentNames, parent: parent, status: status, menu: menu, header_url: header, image_url: image })
            .then(function (data) {
                setLoading(false)
                if (onSaved) {
                    onSaved(data);
                }
            });;
    }
    const toggleChildren = () => {

        setShowChildren(!show_children);

    }

    const onDragEnd = result => {
        const { destination, source, draggableId } = result;

        if (!destination) return;
        if (
            destination.draggableId === source.draggableId &&
            destination.index === source.index
        )
            return;

        var talent = current_childs.find(x => x.id == draggableId)
        var temp = current_childs;

        temp.splice(source.index, 1)
        temp.splice(destination.index, 0, talent)

        var ids = [];
        temp.forEach(child => {
            ids.push(child.id)
        })

        setTalentSortOrder(ids).then(data => {
            console.log(data)
        })

        setCurrentChilds(temp)
    }



    const setSelectedImageGallery = (gallery_item) => {
        switch (selected_image_type) {
            case 'header':
                setHeader(gallery_item?.image)
                break;
            case 'main':
                setImage(gallery_item?.image)
                break;

            default:
                break;
        }
    }


    const openGallery = (type) => {

        setSelectedImageType(type)
        setGalleryModalIsOpen(true)

    }

    const closeGallery = () => {
        setGalleryModalIsOpen(false)
    }

    return (
        <>
            <Gallery setSelectedGalleryItem={setSelectedImageGallery} isOpen={gallery_modal_is_open} key={gallery_modal_is_open} closeGallery={() => { closeGallery() }} />

            <div className="cms-talent-category-edit">
                {/* <div className="box-header with-border">
                    <h3 className="box-title  mt-5">{id ? "Edit Category" : "Add New Category"}</h3>
                </div> */}
                <div className="">
                    <div className="row">
                        <div className="col-md-9">
                            <div className="mb-10 mt-5p">
                                <TabsWidget
                                    tabs={languages ? languages.map(l => ({ key: l.id, label: l.name, icon: 'fa-globe' })) : []}
                                    activeTab={activeLanguage}
                                    onTabChange={setActiveLanguage}
                                    className="cms-level2-tabs"
                                />
                                <div className="cms-level2-tab-content">
                                    {languages && languages.map((language) => (
                                        activeLanguage === language.id && (
                                            <div key={language.id}>
                                                <div className="form-row">
                                                    <input type="text" name="name" className="form-control kfont mb-10 mxw-200" style={{ fontSize: '16px' }} language_id={language.id} value={talentNames && talentNames.find(x => x.language === language.id) ? talentNames.find(x => x.language === language.id).name : ""} onChange={handleOnChange} placeholder={language.name} />
                                                </div>
                                                <div className={`form-row${language.name.toLowerCase().includes('کورد') ? ' kfont rtl' : ''}`}>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={talentNames && talentNames.find(x => x.language === language.id) ? talentNames.find(x => x.language === language.id).description ? talentNames.find(x => x.language === language.id).description : "" : ""}
                                                        onReady={editor => { }}
                                                        onChange={(event, editor) => {
                                                            const data = editor.getData();
                                                            handleDescriptionChange(language.id, data)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group mx-0 mb-2">
                                <img title="Talent Category Image" className="img upload-img  mb-5" onClick={() => { openGallery('main') }} src={image ? image : "/assets/images/default.png"} />
                            </div>
                            <div className="form-group mb-10">
                                <SelectAllTalents
                                    key={id != null ? `talent-parent-${id}` : 'talent-parent-new'}
                                    callback={handleValue}
                                    value={parent}
                                />
                                <div className="clear"></div>
                            </div>
                            <div className="form-group mb-10">
                                <SelectStatus callback={handleValue} value={status} />
                                <div className="clear"></div>
                            </div>
                            <div className="form-group mb-10">
                                <SelectMenu callback={handleValue} value={menu} />
                                <div className="clear"></div>
                            </div>

                           
                        </div>
                    </div>
                </div>
                <div className="mt-4p">
                    <button type="button" onClick={saveChanges} disabled={loading} className="btn btn-primary pull-right">Save Changes</button>
                    {isModal && (
                        <button type="button" onClick={onClose} className="btn btn-default pull-right margin-r-5">Cancel</button>
                    )}
                    
                    {/* {id && <button type="button" onClick={toggleChildren} className="btn btn-secondary pull-right margin-r-5"><i className="fa fa-list"></i></button>
                    } */}
                </div>
            </div>
            <DragDropContext
                onDragEnd={onDragEnd}
            >
                <table className={`table table-bordered ${show_children ? null : "hide"} `}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>

                    <Droppable droppableId={'dopaable'}>
                        {(drop_provided) => (
                            <tbody
                                ref={drop_provided.innerRef}
                                {...drop_provided.dropableProps}
                            >
                                {current_childs && current_childs.map((item, index) => (
                                    <>
                                        <Draggable
                                            key={item.id}
                                            draggableId={`${item.id}`}
                                            index={index}

                                        >
                                            {(provided) => (
                                                <tr

                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    ref={provided.innerRef}
                                                    className={loading === item.id ? "jd loading" : "jd"}
                                                >
                                                    <td>

                                                        <p><b>{getDefaultName(item.names)}</b></p>

                                                    </td>
                                                    <td>
                                                        {item.status &&
                                                            <i className="fa fa-check"></i>
                                                        }
                                                        {!item.status &&
                                                            <i className="fa fa-remove font-color-gray"></i>
                                                        }
                                                    </td>
                                                    <td className="text-right">
                                                        <div className="btn-group">

                                                            <a href={`talents/${item.id}`} className="btn btn-default btn-sm">
                                                                <i className="fa fa-edit"></i>
                                                            </a>
                                                            <a href={`talents/${item.id}/documents`} title="View Documents" className="btn btn-default btn-sm">
                                                                <i className="fa fa-file"></i>
                                                            </a>
                                                            <a href={`talents/${item.id}/questions`} title="View Questions" className="btn btn-default btn-sm">
                                                                <i className="fa fa-question"></i>
                                                            </a>

                                                        </div>
                                                    </td>
                                                </tr>
                                            )}

                                        </Draggable>

                                    </>
                                ))}
                                {drop_provided.placeholder}
                            </tbody>
                        )
                        }
                    </Droppable>

                    <tfoot>
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </tfoot>
                </table>

            </DragDropContext>
            {error && (
                <>
                    <div className="alert alert-danger">
                        {error}
                    </div>
                </>
            )}

            {loading && (
                <>
                    <div className="alert alert-info">
                        please wait...
                    </div>
                </>
            )}
        </>


    )

}
